var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('sb-editor',_vm._g(_vm._b({attrs:{"getTokenMethod":_vm.getUploadToken,"uploadHandler":_vm.editorUploadHandler}},'sb-editor',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }